"use strict";

exports.__esModule = true;
exports.iconMachineNameMapAll = exports["default"] = exports.GlyphBase = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _styledSystem = require("styled-system");

var _iconMap = _interopRequireDefault(require("./icon-map"));

var _glyphs = _interopRequireDefault(require("../glyphs"));

var _custom = _interopRequireDefault(require("../../primitives/custom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var iconMachineNameMapAll = (0, _ramda.merge)(_iconMap["default"], _glyphs["default"]);
exports.iconMachineNameMapAll = iconMachineNameMapAll;
var propTypes = {
  id: _propTypes.string.isRequired
};

var GlyphBase = function GlyphBase(props) {
  var id = props.id;
  var Constructor = (0, _ramda.propOr)((0, _ramda.always)(null), id, iconMachineNameMapAll);
  return /*#__PURE__*/_react["default"].createElement(Constructor, props);
};

exports.GlyphBase = GlyphBase;
GlyphBase.propTypes = propTypes;
var Glyph = (0, _styledComponents["default"])(GlyphBase).withConfig({
  displayName: "glyph__Glyph",
  componentId: "sc-bgakye-0"
})(["", ";", ";"], (0, _styledSystem.compose)(_styledSystem.color, _styledSystem.height, _styledSystem.width), _custom["default"]);
Glyph.displayName = "Modules.Glyph";
var _default = Glyph;
exports["default"] = _default;